import cx from "classnames";
import {
  Button,
  Modal,
  TranslatedString,
  FlexBox,
  AlphaNumericInput,
  Input,
  Dropdown,
} from "components";
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { SampleModalProps } from "./types";
const SampleModal: React.FC<SampleModalProps> = ({
  visible,
  onClose,
  action,
}) => {
  const dropdownList = ["READ", "WRITE"];
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    if (visible) {
      setFirstName("");
      setLastName("");
      setEmail("");
      setRole("");
    }
  }, [visible]);

  return (
    <Modal
      modalHeader={<TranslatedString text="Add a team member" />}
      onClose={onClose}
      visible={visible}
      className="dashboard-add-member-modal"
    >
      <FlexBox justifyBetween alignCenter className="input-section">
        <AlphaNumericInput
          hasLabel
          value={firstName}
          onChange={setFirstName}
          className="br-9 fs-14"
          placeholder={"First Name"}
        />
        <AlphaNumericInput
          hasLabel
          value={lastName}
          onChange={setLastName}
          className="br-9 fs-14"
          placeholder={"Last Name"}
        />
      </FlexBox>
      <FlexBox justifyBetween alignCenter className="input-section mr-t-40">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={"Email Address"}
          className="br-9 fs-14"
          hasLabel
        />
        <Dropdown title="Role" callback={setRole} list={dropdownList} />
      </FlexBox>
      <Button
        onClick={() => {
          action({
            fullName: `${firstName} ${lastName}`,
            email,
            accessType: role,
          });
        }}
        text={<TranslatedString text="Confirm" />}
        className={cx("w-100 mr-t-30")}
      />
    </Modal>
  );
};
export default SampleModal;
